<script>
export default {
    name: 'ServicePlanFeatureCalendahRange',
};
</script>

<script setup>
import ServicePlanFeatureElementsBoolean
    from '@/components/payments/components/service-plan/components/features/components/elements/boolean.vue';

defineProps({
    feature: {
        type:     Object,
        required: true,
    },
});
</script>

<template>
    <service-plan-feature-elements-boolean
        :feature="feature"
        name="Range"
    />
</template>
